var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { Box, Button } from '@mui/material';
import { useOrderColumns } from '../../hooks/useColumns';
import { useFetchOrders } from '../../hooks/useOrder';
import { useOffice } from '../../hooks/useOffice';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import PaymentTimingFilter from '../molecules/PaymentTimingFilter';
import DownloadOrdersCsvButton from '../organisms/DownloadOrdersCsvButton';
var AdminTypicaStockOrdersPage = function () {
    var location = useLocation();
    var t = useTranslation().t;
    var officeItems = useOffice().officeItems;
    var fetchOrders = useFetchOrders({
        type_eq: 'Order::TypicaStockOrder',
    });
    var query = qs.parse(location.search.slice(1));
    var OrderColumns = useOrderColumns({
        role: 'admin',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var renderPaymentTimingFilter = React.useCallback(function (props) { return React.createElement(PaymentTimingFilter, __assign({}, props)); }, []);
    var defaultFilter = React.useCallback(function (field) {
        var filters = query.filters || {};
        return filters[field];
    }, [query]);
    var columns = React.useMemo(function () { return [
        OrderColumns.offerListLink,
        OrderColumns.roasterName,
        {
            field: 'roaster.country.office.name',
            title: t('params.office.name'),
            sorting: true,
            filtering: true,
            lookup: officeItems,
            render: function (order) { return order.roaster.country.office.name; },
            defaultFilter: defaultFilter('roaster.country.office.name'),
        },
        OrderColumns.billingName,
        OrderColumns.storeName,
        OrderColumns.personName,
        OrderColumns.email,
        __assign(__assign({}, OrderColumns.paymentTiming), { title: t('labels.paymentTimingOnAdmin'), filterComponent: renderPaymentTimingFilter }),
        OrderColumns.status,
        OrderColumns.createdAt,
    ]; }, [t, OrderColumns, renderPaymentTimingFilter]);
    return (React.createElement(PageLayout, { title: t('pages.adminTypicaStockOrders.title'), actions: React.createElement(Box, null,
            React.createElement(Button, { sx: { marginRight: 1 }, variant: "contained", component: Link, to: "/admin/new_typica_stock_order" }, t('pages.adminNewTypicaStockOrder.title')),
            React.createElement(DownloadOrdersCsvButton, { type: "typica_stock_order" })) },
        React.createElement(MaterialTable, { model: "order", columns: columns, data: fetchOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
                filtering: true,
            }, detailPath: function (order) { return "/admin/orders/".concat(order.id); } })));
};
export default AdminTypicaStockOrdersPage;
